import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { Store } from "@ngrx/store";
import { Subject } from "rxjs";
import { distinctUntilChanged, takeUntil } from "rxjs/operators";
import { ExternalFacadeModel, MainWallModel, RoofCoveringModel, UnitAreaMeasurement } from "src/app/core/linked-tables";
import { AncillaryBuilding } from "src/app/core/v3/comparable/special-purpose";

@Component({
  selector: 'app-ancillary-building-form',
  templateUrl: './ancillary-building-form.component.html'
})
export class AncillaryBuildingFormComponent implements OnInit, OnDestroy {
  private _id: number
  private _uuid: string
  @Input()
  set building(value: AncillaryBuilding) {
    this._id = value.id

    if (!this._uuid) {
      this.form.patchValue({
        building_name: value.name,
        completion_year: value.completion_year,
        floors: value.floors,
        construction_desc: value.construction_desc,
        main_wall_id: value.main_wall_id,
        external_facade_id: value.external_facade_id,
        roof_covering_id: value.roof_covering_id,
        size: value.size,
        size_unit_id: value.unit_id
      })
      this._uuid = value.uuid
    }
  }

  public mainwalls: MainWallModel[] = [];
  @Input()
  set mainWallOptions(value: MainWallModel[]) {
    this.mainwalls = value
  }

  public externalFacades: ExternalFacadeModel[] = [];
  @Input()
  set externalFacadeOptions(value: ExternalFacadeModel[]) {
    this.externalFacades = value
  }

  public roofCoverings: RoofCoveringModel[] = [];
  @Input()
  set roofCoveringOptions(value: RoofCoveringModel[]) {
    this.roofCoverings = value
  }

  public unitAreaMeasurements: UnitAreaMeasurement[] = []
  @Input()
  set unitAreaMeasurementOptions(value: UnitAreaMeasurement[]) {
    this.unitAreaMeasurements = value
  }

  @Output() buildingChange = new EventEmitter<AncillaryBuilding>()

  form = new FormGroup({
    building_name: new FormControl<string>(null, [Validators.required]),
    completion_year: new FormControl<string>(null),
    floors: new FormControl<number>(null),
    construction_desc: new FormControl<string>(null),
    main_wall_id: new FormControl<number>(null),
    external_facade_id: new FormControl<number>(null),
    roof_covering_id: new FormControl<number>(null),
    size: new FormControl<number>(null),
    size_unit_id: new FormControl<number>(null)
  })


  private _onDestroy$ = new Subject<void>()

  constructor(
    private _ngStore: Store
  ) {}

  ngOnInit(): void {
    this.form.valueChanges.pipe(
      distinctUntilChanged((prev, curr) => {
        if (
          prev.building_name == curr.building_name &&
          prev.completion_year == curr.completion_year &&
          prev.floors == curr.floors &&
          prev.construction_desc == curr.construction_desc &&
          prev.main_wall_id == curr.main_wall_id &&
          prev.external_facade_id == curr.external_facade_id &&
          prev.roof_covering_id == curr.roof_covering_id &&
          prev.size == curr.size &&
          prev.size_unit_id == curr.size_unit_id
        ) {
          return true
        }
        return false
      }),
      takeUntil(this._onDestroy$)
    ).subscribe(formValues => {
      const building = new AncillaryBuilding()
      building.id = this._id
      building.uuid = this._uuid
      building.name = formValues.building_name
      building.completion_year = formValues.completion_year
      building.floors = Number(formValues.floors)
      building.construction_desc = formValues.construction_desc
      building.main_wall_id = formValues.main_wall_id
      building.external_facade_id = formValues.external_facade_id
      building.roof_covering_id = formValues.roof_covering_id
      building.size = formValues.size
      building.unit_id = formValues.size_unit_id
      this.buildingChange.emit(building)
    })
  }

  ngOnDestroy(): void {
    this._onDestroy$.next()
    this._onDestroy$.complete()
  }
}